import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SubcategoriesAction } from '../SubcategoriesAction';
import { SubcategoriesActionsSortingDialog } from '../SubcategoriesActionsSortingDialog';
import sortIcon from '../../../../images/subcategories/sort-action.svg';

export const SubcategoriesActionsSorting = ({
    onToggle,
    opened = false,
}) => {
    const { sortBy } = useSelector(state => state.app.subcategoriesActions);
    const handleDialogClose = useCallback(() => onToggle(false), [onToggle]);

    return <SubcategoriesAction className="asg-subcategories__actions-item--sorting"
        onToggle={onToggle}
        opened={opened}
        iconImage={sortIcon}
        isIconActive={!!sortBy}
        labelTranslationKey="sortingSortBy"
    >
        <SubcategoriesActionsSortingDialog
            show={opened}
            onClose={handleDialogClose}
        />
    </SubcategoriesAction>;
};
